export default __webpack_public_path__ + "static/media/GSK_Signal_Full_Colour_RGB.066652bd.webp";